import { z } from 'zod';
export const onboardingWorkspaceSchema = z.object({
    name: z.string().min(2, 'Workspace name must be at least 2 characters').max(255),
    slug: z
        .string()
        .min(2, 'Slug must be at least 2 characters')
        .max(100)
        .regex(/^[a-z0-9-]+$/, 'Slug must be lowercase letters, numbers, and hyphens only'),
});
export const onboardingApiKeySchema = z.object({
    openRouterApiKey: z
        .string()
        .min(10, 'API key is too short')
        .regex(/^sk-or-/, 'API key should start with sk-or-'),
    aiModel: z.string().optional(),
});
//# sourceMappingURL=onboarding.js.map